export default "__VITE_ASSET__DyuzUcoS__"